const ticket_contacts = {
  email: 'Contact Email',
  first_name: 'Contact First Name',
  last_name: 'Contact Last Name',
  phone_mobile: 'Contact Phone',
};

export default ticket_contacts;
